import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'blank'
})
export class BlankPipe implements PipeTransform {

  transform(input: any, ...args: unknown[]): any {
    // return (input === null || input === undefined) ? 'N/A' : input;
    return (input === null || input === undefined) ? '' : input;
  }

}
